import { useLayoutEffect, useRef } from 'react';

/**
 * Posiciona el dropdown del menú cuenta en coordenadas fixed, alineando el borde
 * derecho del menú con el del trigger y manteniéndolo dentro del viewport.
 */
export function useAccountMenuDropdownPosition(open: boolean) {
  const menuRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);

  useLayoutEffect(() => {
    if (!open) return;

    const menu = menuRef.current;
    const trigger = triggerRef.current;
    if (!menu || !trigger) return;

    const pad = 12;
    const gap = 6;

    const apply = () => {
      const tr = trigger.getBoundingClientRect();
      const mw = menu.offsetWidth;
      const mh = menu.offsetHeight;
      let left = tr.right - mw;
      left = Math.max(pad, Math.min(left, window.innerWidth - mw - pad));
      let top = tr.bottom + gap;
      if (top + mh > window.innerHeight - pad) {
        top = Math.max(pad, tr.top - mh - gap);
      }
      menu.style.setProperty('position', 'fixed');
      menu.style.setProperty('left', `${Math.round(left)}px`);
      menu.style.setProperty('top', `${Math.round(top)}px`);
      menu.style.setProperty('right', 'auto');
    };

    apply();
    let raf1 = 0;
    let raf2 = 0;
    raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(apply);
    });
    window.addEventListener('resize', apply);
    window.addEventListener('scroll', apply, true);

    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
      window.removeEventListener('resize', apply);
      window.removeEventListener('scroll', apply, true);
      menu.style.removeProperty('position');
      menu.style.removeProperty('left');
      menu.style.removeProperty('top');
      menu.style.removeProperty('right');
    };
  }, [open]);

  return { menuRef, triggerRef };
}
